export const METADATA_QUERY_RELAYS = [
  'wss://purplepag.es',
  'wss://relay.nos.social',
  'wss://relay.primal.net'
];
export const RELAYLIST_RELAYS = [
  'wss://purplepag.es',
  'wss://relay.nos.social',
  'wss://indexer.coracle.social'
];
export const ARBITRARY_IDS_RELAYS = [
  'wss://cache2.primal.net/v1',
  'wss://relay.damus.io',
  'wss://relay.nostr.band'
];
export const SEARCH_RELAYS = [
  'wss://relay.nostr.band',
  'wss://nostr.wine',
  'wss://relay.noswhere.com',
  'wss://relay.nos.today'
];
export const BIG_RELAYS_DO_NOT_USE_EVER = [
  'wss://relay.damus.io',
  'wss://nos.lol',
  'wss://relay.primal.net'
];
//# sourceMappingURL=defaults.js.map